import { Helmet } from 'react-helmet';
import CollectionIcon from "src/assets/all-icons/collection-icon.jsx";
import CommunityIcon from "src/assets/all-icons/community-icon.jsx";

import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import ShareIcon from '@/assets/all-icons/share-icon';
import useGoBack from '@/hooks/useGoBack';
import useTranslations from '@/i18n/useTranslations';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';
import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

import './styles/UserNotFound.css';

export default function UserNotFound() {
  const goBackHandler = useGoBack("/");
  const t = useTranslations('common.profile.user_not_found');
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalPath: "/", locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalPath: "/", locale: resolvedLocale });

  return (
    <>
      <Helmet>
        <html lang={resolvedLocale} />
        <title>Profile Not Found | Suarte</title>
        <meta name="description" content="This profile is not available on Suarte." />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="googlebot" content="noindex,nofollow" />
        <link rel="canonical" href={resolvedCanonicalUrl} />
        {alternateUrls.map((alternate) => (
          <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
        ))}
      </Helmet>
      <AppNavigationPage>
        <div className="user-not-found__container">
          <div className="user-not-found__main-content">
            <BackArrowIcon className="user-not-found__back" onClick={goBackHandler}/>

            <ShareIcon className="user-not-found__share"/>

            <UserProfileImage className="user-not-found__image"/>

            <span className="user-not-found__text font-size-medium">
              {t('message')}
            </span>

            <span className="user-not-found__empty-button"/>

            <div className="user-not-found__buttons">
              <CollectionIcon className="user-not-found__icon"/>
              <CommunityIcon className="user-not-found__icon --community"/>
              <ArtlistIcon className="user-not-found__icon"/>
            </div>
          </div>
        </div>
      </AppNavigationPage>
    </>
  );
}
